import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=bf76162e&"
import script from "./recycle.vue?vue&type=script&lang=js&"
export * from "./recycle.vue?vue&type=script&lang=js&"
import style0 from "./recycle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports